import { useSearch } from '@tanstack/react-router';

import type { UserType } from '../providers/permissions/types';
import { isAgentSearch } from '../utils/searchParams';

/** `?agent=true` simulates agent permissions until Salesforce authentication decides them. */
export const useUserType = (): UserType => {
  const search = useSearch({ strict: false });
  // A search that fails the root schema reaches here unvalidated, with `agent` still the URL's
  // string, and one bad param must not turn agent mode off.
  return isAgentSearch(search?.agent) ? 'agent' : 'customer';
};
